import React, { useCallback, useEffect, useRef } from "react";
import { InputGroup } from "@blueprintjs/core";

import { InputRightIcon } from "./Common";

export const Search = ({ disabled, query, onSearch, placeholder, style, autoFocus }: SearchProps) => {
    const input = useRef<HTMLInputElement | null>(null);

    // фокус с курсором в конце: поиск продолжают набирать с того места, где начали
    useEffect(() => {
        const el = input.current;

        if (autoFocus && el) {
            el.focus();
            el.setSelectionRange(el.value.length, el.value.length);
        }
    }, [autoFocus]);

    const onChange = useCallback(
        (e: any) => {
            onSearch(e.target.value);
        },
        [onSearch]
    );

    const clear = useCallback(() => onSearch(""), [onSearch]);

    const right = InputRightIcon({
        hasValue: !!query,
        disabled: disabled,
        onClear: clear,
        icon: "search",
    });

    return (
        <InputGroup
            className={`planr-round-input`}
            inputRef={input}
            disabled={disabled}
            onChange={onChange}
            placeholder={placeholder || "Поиск"}
            rightElement={right}
            value={query}
            style={Object.assign({}, { marginLeft: "16px" }, style)}
        />
    );
};

interface SearchProps {
    query: string;
    onSearch: (query: string) => void;
    disabled?: boolean;
    placeholder?: string;
    style?: React.CSSProperties;
    /** Сразу поставить курсор в поле — в конец уже набранного */
    autoFocus?: boolean;
}
